import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Application } from '../Console';
import './AdminSidebarSubmenu.scss';
import { UserProfileContext } from '../../components/Console/ConsoleLayout';

interface AdminSidebarSubmenuProps {
    isroot: boolean;
    isadmin: boolean;
    application: Application;
    className?: string;
    buttonClassName?: string;
    selectedRoute?: string;
    onSubmenuClick?: (route: string) => void;
    push: (path: string) => void;
}

class AdminSidebarSubmenu extends React.Component<AdminSidebarSubmenuProps, any> {
    static contextType = UserProfileContext;

    private handleClick = (route: string) => {
        this.props.push(route);
        if (this.props.onSubmenuClick) {
            this.props.onSubmenuClick(route);
        }
    };

    public render() {
        const { selectedRoute } = this.props;
        return (
            <div className="sidebar-admin-submenu">
                <button
                    className={`${this.props.buttonClassName ?? 'btn btn-sidebar'} ${selectedRoute === '/admin/user_management' ? 'active-link' : ''}`}
                    onClick={() => this.handleClick('/admin/user_management')}
                >
                    Users
                </button>
                <button
                    style={{ display: this.context.permissions.root ? 'block' : 'none' }}
                    className={`${this.props.buttonClassName ?? 'btn btn-sidebar'} ${selectedRoute === '/admin/management/portal-settings/company' ? 'active-link' : ''}`}
                    onClick={() => this.handleClick('/admin/management/portal-settings/company')}
                >
                    Companies
                </button>
                <button
                    className={`${this.props.buttonClassName ?? 'btn btn-sidebar'} ${selectedRoute === '/admin/role-management' ? 'active-link' : ''}`}
                    onClick={() => this.handleClick('/admin/role-management')}
                >
                    Roles
                </button>
                <button
                    className={`${this.props.buttonClassName ?? 'btn btn-sidebar'} ${selectedRoute === '/admin/dashboard-management' ? 'active-link' : ''}`}
                    onClick={() => this.handleClick('/admin/dashboard-management')}
                >
                    Dashboard
                </button>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path))
    };
};

export default connect(null, mapDispatchToProps)(AdminSidebarSubmenu);
